import React from 'react';
import { useTranslator } from '../components/i18n/useTranslator';

const AuthFormDisclaimerSection = () => {
    const translate = useTranslator('auth', 'disclaimer');

    return (
        <div className="disclaimer">
            {translate('text', undefined, {
                components: {
                    termsLink: <a href="https://policies.google.com/terms" />,
                    privacyLink: <a href="https://policies.google.com/privacy" />,
                },
            })}
        </div>
    );
};

export default AuthFormDisclaimerSection;
